import {UID} from "agora-rtc-sdk-ng";
const shareUseridPrefix = 'user-';

export const getUserIdFromUid = (uid: UID): number => {
    let result = Number.parseInt(uid as string);
    if (typeof uid == 'string' && uid.startsWith(shareUseridPrefix)) {
        result = Number.parseInt(uid.substring(shareUseridPrefix.length));
    }
    return result as number;
}
